<template>
  <div class="space-y-4">
    <div
      class="bg-ontick-graphite-500 space-y-6 rounded px-4 py-6 shadow sm:p-10"
    >
      <h2 class="text-lg font-bold sm:text-2xl">Faça login para continuar</h2>
      <div class="flex flex-col gap-4">
        <custom-input-component
          :value="displayEmail"
          name="email"
          label="E-mail encontrado"
          :locked="true"
        />
        <custom-input-component
          v-model="confirmEmail"
          name="email-confirmation"
          label="Confirmar e-mail"
          placeholder="ontickerson@ontick.com.br"
          type="email"
          autocomplete="email-confirmation"
        />
        <custom-input-component
          :value="password"
          name="password"
          label="Senha"
          placeholder="Digite sua senha"
          type="password"
          autocomplete="password"
        />
      </div>
    </div>
    <div class="flex w-full items-center justify-end">
      <transition name="fade">
        <button
          @click="$emit('registered')"
          class="text-ontick-carbon-900 bg-ontick-blue-600 w-full rounded py-2 px-12 text-sm font-semibold shadow filter transition-all hover:brightness-125 sm:w-auto"
        >
          Avançar
        </button>
      </transition>
    </div>
  </div>
</template>

<script>
import customInputComponent from "./custom-input.component.vue";

export default {
  components: { customInputComponent },

  props: {
    emailInput: {
      type: String,
    },
  },

  data() {
    return {
      confirmEmail: "",
      password: "",
    };
  },

  computed: {
    emailConfirmed() {
      return this.emailInput === this.confirmEmail;
    },
    displayEmail() {
      let username = this.emailInput.split("@")[0];
      let domain = this.emailInput.split("@")[1];
      return `${username.slice(0, 2)}${"*".repeat(
        username.length - 2
      )}@${domain}`;
    },
  },

  watch: {
    user: {
      deep: true,
      handler(val) {
        if (val.password) {
          this.user.passwordTouched = true;
        }
        if (val.confirmPassword) {
          this.user.confirmPasswordTouched = true;
        }
        if (val.email) {
          this.$emit("emailInput", val.email);
        }
      },
    },
  },
};
</script>

<style></style>
